import { useEffect, useState } from 'react';

const WA_LINK = 'https://wa.me/5511984333601?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20especialista%20em%20direito%20imobili%C3%A1rio.';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxurious%20dark%20navy%20blue%20law%20firm%20office%20interior%20with%20marble%20surfaces%20golden%20accents%20sophisticated%20minimalist%20design%20elegant%20legal%20professional%20atmosphere%20premium%20high-end%20workspace%20with%20warm%20ambient%20lighting%20bookshelf%20leather%20chairs%20dark%20dramatic%20lighting&width=1920&height=1080&seq=uitalo-hero-bg1&orientation=landscape"
          alt="Uitalo Bruno Advocacia escritório"
          className="w-full h-full object-cover object-center"
        />
        {/* Deep dark overlay for text readability */}
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(8,31,61,0.92) 0%, rgba(10,42,82,0.85) 50%, rgba(8,31,61,0.88) 100%)' }}></div>
        {/* Subtle gold accent line at bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}></div>
      </div>

      {/* Decorative gold elements */}
      <div className="absolute top-1/4 left-0 w-1 h-48 opacity-30" style={{ background: 'linear-gradient(180deg, transparent, #D4AF37, transparent)' }}></div>
      <div className="absolute top-1/4 right-0 w-1 h-48 opacity-30" style={{ background: 'linear-gradient(180deg, transparent, #D4AF37, transparent)' }}></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-12 text-center">
        {/* Gold ornament */}
        <div
          className={`flex items-center justify-center gap-4 mb-8 transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <div className="h-px w-20 md:w-32" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37)' }}></div>
          <span className="font-sans text-xs tracking-[4px] uppercase font-light" style={{ color: '#D4AF37' }}>
            Direito Imobiliário Estratégico
          </span>
          <div className="h-px w-20 md:w-32" style={{ background: 'linear-gradient(90deg, #D4AF37, transparent)' }}></div>
        </div>

        {/* Main title */}
        <h1
          className={`font-serif text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 transition-all duration-1000 delay-200 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ color: '#F5F5F5' }}
        >
          Especialista em{' '}
          <span style={{ color: '#D4AF37' }}>Direito Imobiliário</span>{' '}
          Estratégico
        </h1>

        {/* Subtitle */}
        <p
          className={`font-sans text-base md:text-xl font-light leading-relaxed max-w-3xl mx-auto mb-10 transition-all duration-1000 delay-400 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ color: '#D9D9D9' }}
        >
          Soluções jurídicas completas para regularização, estruturação e segurança
          do seu patrimônio imobiliário.
        </p>

        {/* CTA Buttons */}
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-600 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 px-8 py-4 font-sans font-semibold text-sm tracking-wider uppercase whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
            style={{ background: '#D4AF37', color: '#0A2A52', borderRadius: '2px' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = '#C29B2E'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = '#D4AF37'; }}
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Falar com Especialista
          </a>

          <a
            href="#atuacao"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#atuacao')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2 px-8 py-4 font-sans font-medium text-sm tracking-wider uppercase whitespace-nowrap cursor-pointer transition-all duration-300 border"
            style={{ color: '#F5F5F5', borderColor: 'rgba(212,175,55,0.5)', borderRadius: '2px' }}
            onMouseEnter={(e) => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.borderColor = '#D4AF37';
              el.style.color = '#D4AF37';
            }}
            onMouseLeave={(e) => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.borderColor = 'rgba(212,175,55,0.5)';
              el.style.color = '#F5F5F5';
            }}
          >
            Conhecer Atuação
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer"
        style={{ color: 'rgba(212,175,55,0.6)' }}
        onClick={() => document.querySelector('#sobre')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <span className="font-sans text-xs tracking-widest uppercase font-light">Role para baixo</span>
        <i className="ri-arrow-down-s-line text-xl animate-bounce"></i>
      </div>
    </section>
  );
}